/**
 * @author xyguo
 * @description 证书管理页面
 * @Date 2020/9/10
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '../../../tool'
import "./index.less";
let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin,WizModal,WizTag} = component_tool;

const sys_biz_enum =(e)=>{
  let biz = {
    0: { name: '课程'},
    1: { name: '考试'},
    2: { name: '问卷' },
    8: { name: '线下课程'},
    12: { name: '路径必修'},
    13: { name: '路径选修'},
    32: { name: '路径阶段'},
    39: { name: '路径'},
  }
return biz[e] || {}
}

class CertList extends WizContainer {

  componentName = 'CertList';

  constructor(props) {
    super(props);
    this.state = {
      showVisible: false,
      relationContent: undefined,
      relationContentModalKey:new Date().getTime()
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '证书名称',
        field: 'name',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书分类',
        field: 'categoryStr',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      // {
      //   headerName: '课程编码',
      //   field: 'code',
      //   width: 20,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      {
        headerName: '适用范围',
        field: 'scope',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书类型',
        field: 'classify',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书类别',
        field: 'type',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '证书级别',
        field: 'levelName',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否自动挂靠',
        field: 'autoLink',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否允许共建',
        field: 'allowUnite',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否允许申请',
        field: 'needCheck',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        if (d.classify == 1){
          d.classify = '个人';
        }else {
          d.classify = '店端';
        }
        if (d.type == 1){
          d.type = '培训';
        }else {
          d.type = '社会';
        }
        if (d.autoLink == 0){
          d.autoLink = '否'
        }else{
          d.autoLink = '是';
        }
        if (d.allowUnite == 0){
          d.allowUnite = '否'
        }else {
          d.allowUnite = '是'
        }
        if (d.needCheck == 0){
          d.needCheck = '否'
        }else{
          d.needCheck = '是'
        }
        if (d.state == 0){
          d.state = '无效'
        }else{
          d.state = '有效'
        }

        let levelData = [
          {code: 0, msg: '初级'},
          {code: 1, msg: '中级'},
          {code: 2, msg: '高级'},
          {code: 3, msg: '一星'},
          {code: 4, msg: '二星'},
          {code: 5, msg: '三星'},
          {code: 6, msg: '四星'},
          {code: 7, msg: '五星'},
          {code: 8, msg: '六星'},
          {code: 9, msg: '七星'}
        ];
        
        levelData.forEach(e=>{
          if(e.code=== d.level){
            d.levelName = e.msg
          }
        })

      let _d = { ...d }
      let authData = d['authData']
      let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['scope'] = target
        _data.push(_d)
      });

      WizBrowserExport({
        title: '证书信息',
        sheetName: '证书信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '证书信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  propsAndStateOnChange = {
    getRelationContent: this._getRelationContentOver.bind(this)
  }

  /**
   * 条件内容解析
   */
   _conditionInfo = (beforeCondition) => {
    if (!beforeCondition || beforeCondition['bizId'] < 0) {
      return '暂无前置条件'
    } else {
      let { conditionList = [], conditionGroupList = [] } = beforeCondition
      let renderCondition = (conditionList = [], conditionGroupList = []) => {
        return conditionList.map(({ conditionBizType, conditionBizName, conditionType }, index) => (
          <span className='condition-row' key={index}>
            <WizTag color='blue'>完成:{' [ ' + sys_biz_enum(conditionBizType).name + ' ] '}{conditionBizName}</WizTag>
            {/* {(index !== conditionList.length - 1 || conditionGroupList.length) ? (conditionType === 0 ? '与 ' : '或 ') : ''} */}
            { index === conditionList.length - 1 ? (conditionGroupList.length ? conditionGroupList[0].conditionType === 0 ? '与 ' : '或 ' : '') : conditionList[index + 1].conditionType === 0 ? '与 ' : '或 '}
          </span>
        ))
      }
      return (
        <div className='cert-item-condition-info'>
          您需要完成以下条件才能获得证书:
          <div className='condition-view'>
            {renderCondition(conditionList, conditionGroupList)}
            {conditionGroupList.map(({ children, conditionType }, index) => {
              return children && children.length ? (
                [<div className='group' key={index}>
                  <div>完成条件组:</div>
                  <div style={{ paddingLeft: 8 }}>{renderCondition(children)}</div>
                </div>,
                // <div>{(index !== conditionGroupList.length - 1) ? (conditionType === 0 ? '与 ' : '或 ') : ''}</div>
                <div>{(index !==  conditionGroupList.length - 1) ? (conditionGroupList[index + 1].conditionType === 0 ? '与 ' : '或 ') : ''}</div>,
                ]
              ) : null
            }).filter(Boolean)}
          </div>
        </div>
      )
    }
  }

  _getRelationContentOver(nextProps, nextState) {
    if (nextProps.getRelationContent.code == 1) {
      nextState['relationContent']= nextProps.getRelationContent.data
      nextState['showVisible']=true
      nextState['relationContentModalKey']=new Date().getTime()
    } else {
      wizNotice.error('获取失败：' + nextProps.getRelationContent.msg);
    }
    return true;
  }

  getRelationContent(bizId){
    this.doAction({
      path: 'beforeCondition/list',
      payload: {
        key: 'beforeCondition@listNew',
        apiParams: {bizType:21,bizId:bizId }
      }
    })
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig:templateConfig(
        {
          _btnShowRelationContentFun: (e) => {
            this.getRelationContent(e.id);
          }
        }
      ),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        UpdateProgramStatus:this._handleCMD,
        export:this._handleFile
      },
    })

    let lookRelationContentModal = {
      title: '查看详情',
      visible: this.state.showVisible,
      footer: null,
      width: 500,
      onCancel: (e) => {
        this.setState({
          showVisible: false,
          relationContent: undefined,
        });
      },
    }

    return <>
        <WizReduxTemplate {..._reduxTemplateCofig} /> 
        <WizModal key={'relationContentModalKey'+this.state.relationContentModalKey} {...lookRelationContentModal}>
          {this._conditionInfo(this.state.relationContent)}
        </WizModal>
        </>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { beforeCondition } = state;
  const getRelationContent = modelUtils.getModelEntity(beforeCondition, 'beforeCondition@listNew');
  const load = modelUtils.getLoadingState(state, 'beforeCondition');
  return {
    getRelationContent,
    ...load
  }
};

export default connect(mapStateToProps)(CertList);
